export default "__VITE_ASSET__ohGHc$5u__"